import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../utils/agent";
import * as API from "../../../utils/apiPath";

// ===============================
// Load calendar & meeting list
// ===============================
export const loadScheduleCalendar = createAsyncThunk(
  "calendar/loadScheduleCalendar",
  async (request, { rejectWithValue, dispatch }) => {
    try {
      // Attach timezone (same as old code)
      request = { 
        ...request, 
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone 
      };

      // API GET call with params (OLD LOGIC)
      const response = await agent.get(
        API.LOAD_CUSTOMER + "/web-schedule-meetings",
        { params: request }
      );

      const data = response?.data?.data?.data || [];
      const pagination = response?.data?.data?.pagination || null;

      // Return EXACT structure old reducer expects
      return {
        data,
        pagination
      };

    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to load meeting data");
    }
  }
);


// ===============================
// Update join status
// ===============================
export const updateJoinStatus = createAsyncThunk(
    "calendar/updateJoinStatus",
    async (request, { rejectWithValue }) => {
        try {
            const response = await agent.post(
                API.LOAD_CUSTOMER + "/web-update-meeting-joined-status",
                request
            );
            return { ...request, message: response.data.message };
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || "Failed to update join status");
        }
    }
);

// ===============================
// Update meeting status
// ===============================
export const updateMeetingStatus = createAsyncThunk(
    "calendar/updateMeetingStatus",
    async ({ params, status, page }, { dispatch, rejectWithValue }) => {
        try {
            const request = {
                id: params.id,
                status: status,
            };
            const response = await agent.post(
                API.LOAD_CUSTOMER + "/web-update-meeting-status",
                request
            );
            if (response.status === 200) {
                return {
                    id: params.id,
                    status,
                    message: response.data.message,
                };
            }
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || "Failed to update meeting status");
        }
    }
);

// ===============================
// Slice
// ===============================
const scheduleListingCalendarSlice = createSlice({
    name: "scheduleListingCalendar",

    initialState: {
        scheduleList: [],
        loading: false,
        error: null,
        popoverEvent: false,
    },

    reducers: {
        setPopoverEvent(state, action) {
            state.popoverEvent = action.payload;
        },
    },

    extraReducers: (builder) => {
        builder
            // LOAD LIST
            .addCase(loadScheduleCalendar.pending, (state) => {
                state.loading = true;
            })
            .addCase(loadScheduleCalendar.fulfilled, (state, action) => {
                state.loading = false;
                state.scheduleList = action.payload;
            })
            .addCase(loadScheduleCalendar.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // JOIN STATUS UPDATE
            .addCase(updateJoinStatus.fulfilled, (state, action) => {
                const index = state.scheduleList.findIndex(
                    (item) => item.id === action.payload.id
                );
                if (index > -1) {
                    state.scheduleList[index].join_status_creator = action.payload.status;
                    state.scheduleList[index].join_status_receiver = action.payload.status;
                }
            })

            // MEETING STATUS UPDATE
            .addCase(updateMeetingStatus.fulfilled, (state, action) => {
                const index = state.scheduleList.findIndex(
                    (item) => item.id === action.payload.meeting_id
                );
                if (index > -1) {
                    state.scheduleList[index].mStatus = action.payload.status;
                }
            });
    },
});

export const { setPopoverEvent } = scheduleListingCalendarSlice.actions;
export default scheduleListingCalendarSlice.reducer;
